import firebase from "firebase";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCs7WBgIEIIJt_NbnQQzWT3RMcwog__Wro",
  authDomain: "cie-saledb.firebaseapp.com",
  databaseURL: "https://cie-saledb.firebaseio.com",
  projectId: "cie-saledb",
  storageBucket: "cie-saledb.appspot.com",
  messagingSenderId: "272106797306",
  appId: "1:272106797306:web:550e1dc81347c3a7887143",
  measurementId: "G-MN1MY2DF2S",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

const auth = firebase.auth();
const db = firebase.firestore();

export { auth, db };
export default firebase;
